import { FunctionComponent, useEffect } from 'react';

import ScrollToTopProps from './ScrollToTop.types';

const ScrollToTop: FunctionComponent<ScrollToTopProps> = (
  props: ScrollToTopProps
) => {
  const { className, dependencies } = props;

  useEffect(() => {
    document.getElementsByClassName(className || 'main')[0]?.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies, className]);

  return null;
};

export default ScrollToTop;
